import { motion } from "framer-motion";
import {
  UserRoundCheck, ConciergeBell, UtensilsCrossed, Sun, Gift, Sparkles, CakeSlice, Bath, ArrowUpRight
} from "lucide-react";

const spotlight = [
  { icon: UserRoundCheck, label: "Personal Butler", note: "Where available" },
  { icon: ConciergeBell, label: "Dedicated Concierge", note: "From inquiry to check-out" },
  { icon: UtensilsCrossed, label: "Priority Dining", note: "Themed restaurants, held for you" },
  { icon: Sun, label: "Reserved Sunbeds", note: "Exclusive beach access" },
  { icon: Gift, label: "Nightly Turndown Gifts", note: "Little rituals, quietly done" },
  { icon: Sparkles, label: "Spa Sanctuary Access", note: "Adults-only quiet" },
  { icon: CakeSlice, label: "Special Occasion Experiences", note: "Anniversaries · birthdays · honeymoons" },
  { icon: Bath, label: "Exclusive Resort Privileges", note: "The list is longer than this" },
];

export default function PerksShowcase() {
  return (
    <section id="perks-showcase" className="relative bg-[#F9F6F0] py-24 md:py-40 z-[2]" data-testid="perks-showcase-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.9 }}
          className="grid grid-cols-12 gap-6 mb-16 md:mb-20"
        >
          <div className="col-span-12 md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-[#C5A059]" />
              <span className="eyebrow text-[#C5A059]">The Elevated Difference</span>
            </div>
            <h2 className="font-serif-editorial text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight">
              This is what <span className="italic text-[#C5A059]">elevated</span> looks like.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 flex md:items-end">
            <p className="text-[#1A1A1A]/75 leading-relaxed max-w-md">
              A handful of the privileges included with every escape. Selected because you can feel them from the moment you arrive.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-black/10 border border-black/10">
          {spotlight.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.05 }}
              className="group bg-[#F9F6F0] hover:bg-[#F2ECE0] transition-colors p-6 md:p-8 flex flex-col aspect-square md:aspect-auto md:min-h-[220px]"
              data-testid={`perk-spotlight-${i}`}
            >
              <p.icon size={26} strokeWidth={1.1} className="text-[#C5A059] mb-6 md:mb-10 transition-transform duration-700 group-hover:scale-110" />
              <p className="font-serif-editorial text-lg md:text-2xl leading-tight text-[#1A1A1A] mb-2">{p.label}</p>
              <p className="text-xs md:text-sm text-[#5C5C5C] leading-relaxed mt-auto">{p.note}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.9 }}
          className="mt-16 md:mt-20 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
        >
          <p className="font-serif-editorial text-2xl md:text-3xl italic text-[#1A1A1A]">
            And that&rsquo;s only the beginning.
          </p>
          <a href="#perks" data-testid="perks-showcase-cta" className="ee-btn-primary self-start md:self-auto">
            See All 22 VIP Perks <ArrowUpRight size={14} strokeWidth={1.5} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
